import CampaignTitle from './campaign_title'
import { connect } from 'react-redux'
import { getFullName } from 'griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'
import isOwnerSelector from 'redux/selectors/is_owner'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    displayName: getFullName({
      givenName: campaign.owner.first_name,
      surname: campaign.owner.last_name,
    }),
    title: campaign.title,
    isOwner: isOwnerSelector(state, props),
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignTitle)
